import { Description, Small } from '@casavo/base-ui'
import cn from 'classnames'
import { motion } from 'framer-motion'
import React from 'react'

import { useDevice } from '@/context/Device'

import { detailGalleryButton } from './styles.css'

export const DetailGalleryButton: React.FC<{
  Icon: React.FC
  className?: string
  label: string
  onClick: (event: React.SyntheticEvent<HTMLElement>) => void
}> = ({ Icon, className, label, onClick, ...props }) => {
  const device = useDevice()
  return (
    <motion.button
      className={cn(detailGalleryButton, className)}
      onClick={onClick}
      {...props}
      whileTap={{ scale: 0.92 }}
    >
      <>
        <Icon />
        {device === 'mobile' ? <Small>{label}</Small> : <Description>{label}</Description>}
      </>
    </motion.button>
  )
}
